module.exports = __webpack_public_path__ + "static/media/action.c5433bbb.svg";